import { render, staticRenderFns } from "./WhatsappSendAgain.vue?vue&type=template&id=77f7e2a2&scoped=true"
import script from "./WhatsappSendAgain.vue?vue&type=script&lang=js"
export * from "./WhatsappSendAgain.vue?vue&type=script&lang=js"
import style0 from "./WhatsappSendAgain.vue?vue&type=style&index=0&id=77f7e2a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7e2a2",
  null
  
)

export default component.exports